import { Box, Skeleton } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';
import React from 'react';

const EventPageLoader = () => (
    <Box sx={{
      display: 'flex', 
      justifyContent: 'space-between', 
      height: '100%',
      mt: '70px'
    }}>
      <Box sx={{
        p: { xs: '24px 20px', sm: '50px', lg: '80px 70px 80px 125px', xl: '80px 125px 80px 125px' },
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '8px' }}>
          <Skeleton variant='circular' width='38px' height='38px' sx={{ backgroundColor: Colors.white_a60 }} animation='wave' />
			  	<Skeleton variant='rectangular' width='98px' height='14px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
        </Box>
        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap', mb: '24px' }}>
			  	<Skeleton variant='rectangular' width='40%' height='20px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  	<Skeleton variant='rectangular' width='55%' height='20px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  	<Skeleton variant='rectangular' width='18%' height='20px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  	<Skeleton variant='rectangular' width='22%' height='20px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  </Box>
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', mb: '18px' }}>
			  	<Skeleton variant='circular' width='24px' height='24px' sx={{ backgroundColor: Colors.white_a60 }} animation='wave' />
			  	<Skeleton variant='rectangular' width='112px' height='8px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  </Box>
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', mb: '18px' }}>
			  	<Skeleton variant='circular' width='24px' height='24px' sx={{ backgroundColor: Colors.white_a60 }} animation='wave' />
			  	<Skeleton variant='rectangular' width='112px' height='8px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '12px' }} animation='wave' />
			  </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '34px' }}>
			  	<Skeleton variant='circular' width='24px' height='24px' sx={{ backgroundColor: Colors.white_a60 }} animation='wave' />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
			  	  <Skeleton variant='circular' width='38px' height='38px' sx={{ backgroundColor: Colors.white_a60, opacity: 0.5 }} animation='wave' />
			  	  <Skeleton variant='circular' width='38px' height='38px' sx={{ backgroundColor: Colors.white_a60, opacity: 0.5, transform: 'translateX(-16px)' }} animation='wave' />
			  	  <Skeleton variant='circular' width='38px' height='38px' sx={{ backgroundColor: Colors.white_a60, opacity: 0.5, transform: 'translateX(-32px)' }} animation='wave' />
			  	  <Skeleton variant='rectangular' width='58px' height='38px' sx={{ backgroundColor: Colors.white_a60, borderRadius: '100px', opacity: 0.5, transform: 'translateX(-40px)' }} animation='wave' />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mb: '56px' }}>
			  	<Skeleton 
			  		variant="rectangular" 
			  		height="8px" 
			  		width="112px" 
			  		animation="wave" 
			  		sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px', marginTop: '18px' }}
			  	/>
			  	<Skeleton 
			  		variant="rectangular" 
			  		height="105px" 
			  		animation="wave" 
			  		sx={{ backgroundColor: Colors.white_a10, borderRadius: '8px', border: `1px solid ${Colors.white_a5}` }}
			  	/>
			  	<Skeleton 
			  		variant="rectangular" 
			  		height="105px" 
			  		animation="wave" 
			  		sx={{ backgroundColor: Colors.white_a10, borderRadius: '8px', border: `1px solid ${Colors.white_a5}` }}
			  	/>
			  	<Skeleton 
			  		variant="rectangular" 
			  		height="105px" 
			  		animation="wave" 
			  		sx={{ backgroundColor: Colors.white_a10, borderRadius: '8px', border: `1px solid ${Colors.white_a5}` }}
			  	/>
			  </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
			  	<Skeleton variant="rectangular" height="14px" width="154px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  	<Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
			  		<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="63px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="197px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  		</Box>
			  		<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="188px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="239px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="63px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="129px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  		</Box>
			  		<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="168px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  		</Box>
			  		<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="244px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="63px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="71px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a20, borderRadius: '12px' }}/>
			  		</Box>
			  		<Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="314px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="239px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="63px" animation="wave" sx={{ backgroundColor: Colors.white_a15, borderRadius: '12px' }}/>
			  		</Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '4px', rowGap: '6px' }}>
			  			<Skeleton variant="rectangular" height="12px" width="197px" animation="wave" sx={{ backgroundColor: Colors.white_a10, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a10, borderRadius: '12px' }}/>
			  			<Skeleton variant="rectangular" height="12px" width="118px" animation="wave" sx={{ backgroundColor: Colors.white_a10, borderRadius: '12px' }}/>
			  		</Box>
			  	</Box>
			  </Box>
      </Box>
			<Skeleton variant='rectangular' width='700px' height='100%' sx={{ backgroundColor: Colors.white_a8, display: {xs: 'none', md: 'block'}}} animation='wave' />
    </Box>
  )

export default EventPageLoader